import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

import "./icons"; // icon
// import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import "./styles/index.scss"; // global css
import "./assets/css/reset.css";
import "./assets/css/common.less";

import axios from "axios";
import Vueaxios from "vue-axios";
Vue.use(Vueaxios, axios);

import moment from "moment";
moment.locale("zh-cn"); //设置语言 或 moment.lang('zh-cn');
Vue.prototype.$moment = moment; //赋值使用

import common from "./assets/js/common";
Vue.prototype.$common = common;
import JsFileDownload from "js-file-download";
Vue.prototype.$JsFileDownload = JsFileDownload;

import * as echarts from "echarts";

import {
  LineChart,
  PieChart,
  MapChart,
  ScatterChart,
  BarChart,
} from "echarts/charts";
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  ToolboxComponent,
} from "echarts/components";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
// import districtList from "./assets/js/district";

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  PieChart,
  CanvasRenderer,
  MapChart,
  ScatterChart,
  LineChart,
  LegendComponent,
  BarChart,
  ToolboxComponent,
]);
Vue.prototype.$echarts = echarts;

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
});

let load;
// 设置请求拦截器s
axios.interceptors.request.use(
  (config) => {
    // console.log(config.url);
    // console.log(config.url.indexOf("/REC/DATA/SAVE"));
    if (
      config.url.indexOf("GetToday") < 0 &&
      config.url.indexOf("/REC/DATA/SAVE") < 0
    ) {
      if (!config.headers.Disable) {
        if (config.url == "api/Teacher/Msdy/GetQuestionList") {
          // || config.url == 'api/Manage/Data/GetProblemCount' || config.url == 'api/Manage/Data/GetLiveBroadcast' || config.url == 'api/Manage/Data/GetNumberOfVisits'
          // load = ElementUI.Loading.service({
          //   lock: false,
          //   background: "rgba(0, 0, 0, 0.2)"
          // });
        } else {
          load = ElementUI.Loading.service({
            lock: true,
            background: "rgba(0, 0, 0, 0.2)",
          });
        }
      }
    }
    if (localStorage.getItem("loginToken")) {
      config.headers.Authorization = localStorage.getItem("loginToken");
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 设置响应拦截器
axios.interceptors.response.use(
  (res) => {
    load.close();
    return res;
  },
  (error) => {
    load.close();
    // 如果是正常接口，会走err，err.response.status值为401 进行跳转及删除token的操作
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          localStorage.removeItem("loginToken");
          if (location.hash != "#/") {
            location.reload();
          }
          // console.log(location)
          // var redirect = window.location.href.split('#')[1]
          // location.reload()
          return Promise.reject("登录已过期,请重新登录");
        case 403:
          return Promise.reject("你没权限查询该资源");
        case 404:
          return Promise.reject("你所访问的资源不存在");
        case 500:
          return Promise.reject("服务器出错啦");
      }
    }
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/main.js